import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["email", "userSelect"]
  
  fillEmail(event) {
    const selectedOption = this.userSelectTarget.options[this.userSelectTarget.selectedIndex];
    const userEmail = selectedOption.dataset.email;
    
    if (userEmail) {
      this.emailTarget.value = userEmail;
    }
  }
}

